/* eslint-disable import/no-cycle */
import ContentGroupController from './content-group-controller'

export default ContentGroupController
